import { __assign, __makeTemplateObject, __rest } from "tslib";
import get from 'lodash/get';
import omit from 'lodash/omit';
import * as React from 'react';
import { withProps } from 'recompose';
import styled from 'styled-components';
import asRendition from '../../asRendition';
import { darken, monospace } from '../../utils';
import { align, bold, caps } from '../Txt';
var Base = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\t", ";\n\t", "\n\t", "\n\n  text-decoration: ", ";\n\tcursor: ", ";\n\topacity: ", ";\n\tdisplay: inline-block;\n\n\t&:active,\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"], ["\n\t", "\n\t", ";\n\t", "\n\t", "\n\n  text-decoration: ", ";\n\tcursor: ", ";\n\topacity: ", ";\n\tdisplay: inline-block;\n\n\t&:active,\n\t&:hover {\n\t\tcolor: ",
    ";\n\t}\n"])), align, monospace, caps, bold, function (props) { return props.decor || 'none'; }, function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); }, function (props) { return (props.disabled ? 0.65 : 1); }, function (props) {
    return !props.disabled &&
        darken(get(props.theme.colors, props.color) || props.color);
});
var BaseLink = function (_a) {
    var is = _a.is, blank = _a.blank, children = _a.children, props = __rest(_a, ["is", "blank", "children"]);
    if (props.disabled) {
        props = omit(props, 'href');
    }
    return (React.createElement(Base, __assign({}, props, { as: is, rel: blank ? 'noopener' : undefined, target: blank ? '_blank' : undefined }), children || props.href));
};
var setDefaultProps = withProps(function (props) {
    return Object.assign({
        color: "primary.main",
    }, props);
});
export var Link = asRendition(BaseLink, [setDefaultProps], ['color']);
var templateObject_1;
